import React, { useState } from 'react';
import { isEmpty, prop, without } from 'ramda';
import superagent from 'superagent';
import store from '../store/store';
import { ajaxAction } from '../ajax/ajax.utils';
import { iFrameScript } from 'dot-utils';
import { PlacementAjaxOperation } from './placements.models';
import CircleIconButton from '../elements/CircleIconButton';
import { AdminScreen } from '../admin/admin.models';
import { triggerResetCache } from './placements.utils';

interface Props {}

function PlacementPublishContainer({}: Props) {
	const [loading, setLoading] = useState(false);
	const handleClick = async () => {
		const state = store.getState();
		const {
			selectedWidget,
			selectedTaxonomyType,
			selectedTaxonomies,
			selectedInsertionPoint,
			selectedInsertionNumber,
			selectedAlignment,
			selectedFormat,
			currentPlacementId,
		} = state.placements;

		if (!selectedTaxonomies || isEmpty(selectedTaxonomies)) {
			alert('Please select at least one category or tag');
			return;
		}

		if (isEmpty(selectedFormat)) {
			alert('Please choose at least one format');
			return;
		}

		setLoading(true);
		const data: any = {
			operation: PlacementAjaxOperation.ADD,
			widget_id: selectedWidget.id,
			widget_title: selectedWidget.title,
			taxonomy_type: selectedTaxonomyType,
			taxonomies: without(['all'], selectedTaxonomies.map(prop('term_id'))),
			insertion_point: selectedInsertionPoint,
			insertion_number: selectedInsertionNumber,
			alignment: selectedAlignment,
			format: selectedFormat,
			all_taxonomies: selectedTaxonomies.some((t) => t.term_id === 'all'),
		};

		if (currentPlacementId) {
			data.operation = PlacementAjaxOperation.UPDATE;
			data.placement_id = currentPlacementId;
		}

		const result = await ajaxAction({
			action: 'dot_press_placement',
			data,
		});
		triggerResetCache();
		setLoading(false);
		store.dispatch.admin.setScreen(AdminScreen.Saved);
	};
	return (
		<div>
			<CircleIconButton onClick={handleClick}>
				{(loading && 'Publishing') || 'Publish'}
			</CircleIconButton>
		</div>
	);
}

export default PlacementPublishContainer;
